/**
 * 简单的教师测试组件
 * 用于验证教师形象能否正常显示
 */

import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
} from 'react-native';

const SimpleTeacherTest: React.FC = () => {
  const [showTeacher, setShowTeacher] = useState(false);

  useEffect(() => {
    // 3秒后自动显示教师
    const timer = setTimeout(() => {
      setShowTeacher(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!showTeacher) {return null;}

  return (
    <View style={styles.container}>
      {/* 对话气泡 */}
      <View style={styles.speechBubble}>
        <Text style={styles.messageText}>
          你好！我是小莉老师！这是一个简单的测试！😊
        </Text>
        <TouchableOpacity
          style={styles.closeButton}
          onPress={() => setShowTeacher(false)}
        >
          <Text style={styles.closeButtonText}>×</Text>
        </TouchableOpacity>
      </View>

      {/* 简化的教师形象 */}
      <View style={styles.teacher}>
        <Text style={styles.teacherEmoji}>👩‍🏫</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 120,
    right: 20,
    alignItems: 'center',
    zIndex: 1000,
  },
  speechBubble: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: 12,
    marginBottom: 8,
    maxWidth: 200,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    borderWidth: 2,
    borderColor: '#e8f4fd',
    position: 'relative',
  },
  messageText: {
    fontSize: 14,
    color: '#2c3e50',
    lineHeight: 20,
    textAlign: 'center',
    fontWeight: '500',
  },
  closeButton: {
    position: 'absolute',
    top: -5,
    right: -5,
    backgroundColor: '#ff6b6b',
    borderRadius: 12,
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 16,
  },
  teacher: {
    backgroundColor: '#f0f0f0',
    borderRadius: 40,
    width: 80,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#ddd',
  },
  teacherEmoji: {
    fontSize: 40,
  },
});

export default SimpleTeacherTest;
